const Flickity = require('flickity');
const FlickityLazy = require('flickity-bg-lazyload');
const FlickityFull = require('flickity-fullscreen');
import 'flickity/css/flickity.css'
import 'flickity-fullscreen/fullscreen.css'


const elem = document.querySelector('.inicio .slider .main-carousel')
if(elem){


        const flkty = new Flickity( elem, {
        cellAlign: 'left',
        contain: true,
        fullscreen: false,
        lazyLoad: 0,
        wrapAround: true,
        autoPlay: 6500,
        pauseAutoPlayOnHover: false,
        dragThreshold: 10,
        selectedAttraction: 0.2,
        friction: 0.8,
        on:{
        change: function( index ) {
            // console.log( 'Slide changed to' + index );
          }
        }
    });
}